<template>
  <div>
    
    <Menu />

    <section v-if="!loading">

    <div style="border-top-left-radius: 10px; border-top-right-radius:10px; z-index: 999; position: fixed; bottom: 0; left: 50%; transform: translateX(-50%); padding: 10px; background-color: #efefef;" class="text-center">
      <div class="container">
        <div class="d-flex justify-content-center">
          <div class="d-flex align-items-center me-4">
            <i class="bi bi-whatsapp display-5 text-danger me-2"></i>
            <a v-if="this.agent.first_name != null" target="_blank" class="h5 text-decoration-none text-danger" :href="whatsappLink">
              <strong>{{ agent.first_name }}</strong>
            </a>
          </div>
          <div class="d-flex align-items-center">
            <i class="bi bi-whatsapp display-5 text-danger me-2"></i>
            <a v-if="this.agent_2.first_name != null" target="_blank" class="h5 text-decoration-none text-danger" :href="whatsappLink_2">
              <strong>{{ agent_2.first_name }}</strong>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="banner" class="mt-5" v-if="!loading">
      <div class="container-fluid g-0">
        <div class="row justify-content-center g-0">
          <div class="col-12">
            <div class="porfolio-banner property-hero">
              <img
                :src="this.ogListing[0].listing_images[0]"
                class="property-hero-image"
              />
              <div class="property-title-stack pt-5">
                <div v-if="primaryStatus" class="property-status-strip property-status-strip-primary">{{ primaryStatus }}</div>
                <h1 v-if="heroMarketingHeading" class="property-title-block text-md-start text-center p-4" style="text-transform: uppercase;"><strong>{{ heroMarketingHeading }}</strong><br/> {{ formattedPrice }}</h1>
                <h1 v-else class="property-title-block text-md-start text-center p-4" style="text-transform: uppercase;"><strong>{{ this.ogListing[0].property_type }}</strong>&nbsp; {{ ogListing[0].loc_suburb }}, {{ ogListing[0].loc_region }}<br/> {{ formattedPrice }}</h1>
                <div v-if="secondaryStatuses.length" class="property-status-strip property-status-strip-secondary">{{ secondaryStatusText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>  
    </div>

    <div class="wrapper">
      <div class="container">
        <div class="row justify-content-center pb-5 mb-5 pt-5">
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].land_size !== 0">
            <div class="prop-details"><span>Land Size</span>{{ ogListing[0].land_size }}<span>{{ ogListing[0].measurement_type }}</span></div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].building_size !== 0">
            <div class="prop-details"><span>Building Size</span>{{ ogListing[0].building_size }}<span>{{ ogListing[0].building_measurement_type }}</span></div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].bedrooms !== 0">
            <div class="prop-details"><span>Bedrooms</span>{{ ogListing[0].bedrooms }}</div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].bathrooms !== 0">
            <div class="prop-details"><span>Bathrooms</span>{{ ogListing[0].bathrooms }}</div>
          </div>
          <div class="col-md-2 col-sm-6" v-if="ogListing[0].garages !== 0">
            <div class="prop-details"><span>Garages</span>{{ ogListing[0].garages }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid bg-light">

      <div class="row">
        <div class="col-12 text-center">
          <h2 class="pt-5"><strong>CONTACT DETAILS</strong></h2>
        </div>
      </div>
      
      <div class="row justify-content-center pt-5 pb-5">
        
        <div class="col-md-4 text-center" v-if="this.agent.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent.first_name }} {{ agent.last_name }}</strong></h3>
                <div v-if="!contactRequested">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested = true">Details</button></center>
                </div>
                <div v-if="contactRequested">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent.email_address"><i class="bi bi-envelope-fill"></i> {{ agent.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 text-center" v-if="this.agent_2.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent_2.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_2.first_name }} {{ agent_2.last_name }}</strong></h3>
                <div v-if="!contactRequested_2">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested_2 = true">Details</button></center>
                </div>
                <div v-if="contactRequested_2">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_2.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_2.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_2.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_2.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink_2" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4 text-center" v-if="this.agent_3.agent_photo">
          <div class="container">
            <div class="row pt-4">
              <div class="col-md-5">
                <img :src="this.agent_3.agent_photo" style="border-radius: 30px;" class="img img-fluid" />
              </div>
              <div class="col-md-7 text-center">
                <h3 class="switch-blue mb-3 mt-4 text-center"><strong>{{ agent_3.first_name }} {{ agent_3.last_name }}</strong></h3>
                <div v-if="!contactRequested_3">
                  <center><button class="btn btn-primary filter-btn" v-on:click="contactRequested_3 = true">Details</button></center>
                </div>
                <div v-if="contactRequested_3">
                  <p style="line-height: 26px;"><a style="text-decoration: none;" class="switch-blue" :href="'tel:' + agent_3.cell_number"><i class="bi bi-telephone-fill"></i> {{ agent_3.cell_number }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="'mailto:' + agent_3.email_address"><i class="bi bi-envelope-fill"></i> {{ agent_3.email_address }}</a><br/>
                  <a style="text-decoration: none;" class="switch-blue" :href="whatsappLink_3" target="_blank"><i class="bi bi-whatsapp"></i> Whatsapp</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-md-12 py-5 px-3">
          <center><h2><strong>Description</strong></h2></center>
          <p class="pt-5 property-description" v-html="
            (ogListing[0].description || ogListing[0].marketing_description || listing.ai_long_description || listing.ai_description || '')
            .replace(/ΓÇó/g, '•')   /* bullet points */
            .replace(/ΓÇô/g, '–')   /* en dash */
            .replace(/â€™/g, '’')   /* right single quote */
            .replace(/â€œ/g, '“')   /* left double quote */
            .replace(/â€/g, '”')   /* right double quote */
            .replace(/â€/g, '…')    /* ellipsis */
            .replace(/┬▒/g, '±')    /* plus-minus */
            .replace(/ΓÇÖ/g, '\'')
          ">
          </p>
        </div>
      </div>
    </div>

    <div class="wrapper">
      <div class="container-fluid">
        <div class="row mt-5">
          <div class="col-12 align-self-center my-4">
            <div v-if="youtubeEmbedUrl" class="property-video-wrap">
              <iframe
                class="property-video-frame"
                width="100%"
                height="515"
                :src="youtubeEmbedUrl"
                title="Property video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin"
                allowfullscreen
              ></iframe>
            </div>

            <div class="position-relative text-center">
              <h2><strong>Gallery</strong></h2>

              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-6" v-for="(item, index) in this.ogListing[0].listing_images">
                      <img :src="item" class="img-fluid py-2" />
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    </section>

    <Footer />
  
  </div>
</template>

<script>
import Menu from '@/components/Menu.vue';
import Footer from '@/components/Footer.vue';
import ContactForm from '@/components/ContactForm.vue';
import { fetchPublicAgent, fetchPublicPropertyByReference, formatPropertyPrice, getPrimaryPropertyStatus, getSecondaryPropertyStatuses, normaliseYouTubeVideoId } from '@/services/winelandsApi';

export default {
  components: {
    Menu, Footer, ContactForm
  },
  data() {
    return {
      listing: { 
        data: {
          listing: [
            { on_show: false }
          ]
        }
      },
      ogListing: [
        {
          listing_images: []
        }
      ],
      agent: { },
      agent_2: { },
      agent_3: { },
      loading: true,
      template: 1,
      activeImageIndex: -1,
      isImageExpanded: false,
      isImageClicked: false,
      originalListings: null,
      listings: null,
      contactRequested: false,
      contactRequested_2: false,
      contactRequested_3: false,
      whatsappLink: '',
      whatsappLink_2: '',
      whatsappLink_3: '',
    };
  },
  mounted() {
    this.fetchListing();
  },
  computed: {
    heroMarketingHeading() {
      const listing = this.ogListing[0] || {}
      return String(listing.marketing_heading || '')
        .replace(/<br\s*\/?>/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim()
    },
    primaryStatus() {
      return getPrimaryPropertyStatus(this.ogListing[0])
    },
    secondaryStatuses() {
      return getSecondaryPropertyStatuses(this.ogListing[0])
    },
    secondaryStatusText() {
      return this.secondaryStatuses.join(' • ')
    },
    youtubeVideoId() {
      const listing = this.ogListing[0] || {}
      return normaliseYouTubeVideoId(listing.video_id || listing.virtual_tour || '')
    },
    youtubeEmbedUrl() {
      return this.youtubeVideoId
        ? 'https://www.youtube.com/embed/' + encodeURIComponent(this.youtubeVideoId) + '?rel=0&playsinline=1'
        : ''
    },

    formattedPrice() {
      return formatPropertyPrice(this.ogListing[0]);
    },
    formattedDescription() {
      const rawDescription = this.listing.ai_long_description || '';
      const sentences = rawDescription.split('. ');
      const paragraphs = [];
      for (let i = 0; i < sentences.length; i += 3) {
        const paragraph = sentences.slice(i, i + 3).join('. ');
        if (!paragraph.endsWith('.')) {
          paragraphs.push(paragraph + '.');
        } else {
          paragraphs.push(paragraph);
        }
      }
      return paragraphs;
    },
    currentUrl() {
      return encodeURIComponent(window.location.href)
    },
    facebookShareLink() {
      return `https://www.facebook.com/sharer/sharer.php?u=${this.currentUrl}`
    },
    linkedinShareLink() {
      return `https://www.linkedin.com/sharing/share-offsite/?url=${this.currentUrl}`
    },
    pinterestShareLink() {
      return `https://www.pinterest.com/pin/create/button/?url=${this.currentUrl}`;
    },
    twitterShareLink() {
      const text = encodeURIComponent("Luxury property presented by Chas Everitt Luxury Portfolio");
      return `https://twitter.com/intent/tweet?url=${this.currentUrl}&text=${text}`;
    },
  },
  methods: {
    printToPDF() {
      window.print();
    },
    fetchListing: async function () {
      this.loading = true
      try {
        const detail = await fetchPublicPropertyByReference(this.$route.params.webRef)
        this.ogListing = [detail.listing]
        this.listing = detail.payload

        const agents = await Promise.all([
          fetchPublicAgent(detail.listing.agent),
          fetchPublicAgent(detail.listing.agent_2),
          fetchPublicAgent(detail.listing.agent_3)
        ])
        this.agent = agents[0]
        this.agent_2 = agents[1]
        this.agent_3 = agents[2]
        this.whatsappLink = this.makeWhatsappLink(this.agent.cell_number)
        this.whatsappLink_2 = this.makeWhatsappLink(this.agent_2.cell_number)
        this.whatsappLink_3 = this.makeWhatsappLink(this.agent_3.cell_number)
      } catch (error) {
        console.log(error)
      }

      this.loading = false
    },
    makeWhatsappLink(number) {
      if (!number) return ''
      const cleanedNumber = String(number).replace(/\D/g, '')
      const formattedNumber = cleanedNumber.startsWith('27') ? cleanedNumber : '27' + cleanedNumber.replace(/^0/, '')
      return `https://wa.me/${formattedNumber}?text=Hello! I am interested in the property I found on your Portfolio website: ${window.location.href}`
    },
    expandImage(index) {
      this.activeImageIndex = index
      this.isImageExpanded = true
      this.isImageClicked = true
    }
  }
};
</script>

<style scoped>
/* Keep line breaks and blank lines as entered in the manager's textarea.
   Leave the existing description HTML handling unchanged. */
.property-description {
  white-space: pre-line;
  overflow-wrap: break-word;
  line-height: 1.65;
}

.property-hero {
  position: relative;
  overflow: hidden;
  display: block !important;
  align-items: initial !important;
  justify-content: initial !important;
}
.property-hero-image {
  display: block;
  width: 100%;
  height: auto;
}
.property-title-stack {
  position: absolute;
  z-index: 5;
  top: 24px;
  left: 24px;
  right: auto;
  bottom: auto;
  width: auto;
  max-width: calc(100% - 48px);
  transform: none;
  display: block !important;
}
.property-title-block {
  position: static !important;
  top: auto !important;
  right: auto !important;
  bottom: auto !important;
  left: auto !important;
  display: block;
  width: fit-content !important;
  max-width: min(720px, calc(100vw - 96px)) !important;
  margin: 0 !important;
  padding: 18px 20px !important;
  background: rgba(255, 255, 255, .86);
}
.property-status-strip {
  display: block;
  width: fit-content;
  max-width: 100%;
  margin-left: 0;
  padding: 7px 12px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: .02em;
  line-height: 1.2;
  text-align: left;
  text-transform: uppercase;
  white-space: normal;
}
.property-status-strip-primary {
  margin-bottom: 8px;
  background: #e00233;
}
.property-status-strip-secondary {
  margin-top: 8px;
  background: #103162;
  font-size: 13px;
}
.property-video-wrap {
  width: 100%;
}
.property-video-frame {
  display: block;
  width: 100%;
  border: 0;
}
@media (max-width: 767px) {
  .property-title-stack {
    top: 12px;
    left: 12px;
    width: auto;
    max-width: calc(100% - 24px);
  }
  .property-title-block {
    width: fit-content !important;
    max-width: calc(100vw - 48px) !important;
    padding: 14px 16px !important;
    background: rgba(255, 255, 255, .92);
    font-size: 24px;
  }
  .property-status-strip {
    max-width: 100%;
    margin-left: 0;
    padding: 6px 10px;
    font-size: 12px;
  }
  .property-status-strip-primary {
    margin-bottom: 6px;
  }
  .property-status-strip-secondary {
    margin-top: 6px;
    font-size: 11px;
  }
  .property-video-frame {
    height: 260px;
  }
}
.fixed-tags {
  position: fixed;
  top: 50%;
  right: 0;
  z-index: 1000;
}
.expanded {
  transform: scale(1.2);
  z-index: 1;
}
.social-links{
  position: unset;
  display: inline;
  float: right;
  margin-right: 20px;
}
.force-height {
  height: 300px;
  object-fit: cover;
}
.carousel-control-next-icon {
  background-color: red;
  border-radius: 25px;
  font-size: 10px;
}
.carousel-control-prev-icon {
  background-color: rgba(0, 0, 0, 1);
  border-radius: 25px;
  font-size: 10px;
}
</style>
